<h1 mat-dialog-title>{{ "shared.countdown_dialog.title" | translate }}</h1>
<mat-dialog-content class="mat-typography">
  <h3>{{ countDownText }}</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>
    {{ "shared.countdown_dialog.close" | translate }}
  </button>
</mat-dialog-actions>
